import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../LanguageContext";
import { ThemeContext } from "../../contexts/ThemeContext";

const Breadcrumbs = () => {
  const location = useLocation();
  const { isRTL } = useLanguage();
  const { isDarkMode } = useContext(ThemeContext);

  const pathnames = location.pathname.split("/").filter((x) => x);

  const breadcrumbNameMap = {
    catalog: isRTL ? "الكتالوج" : "Catalog",
    "swiss-bar": isRTL ? "السبائك السويسرية" : "Swiss Bar",
    // Add more mappings as needed
  };

  return (
    <nav
      className={`${
        isDarkMode ? "bg-black text-white" : "bg-gray-100 text-black"
      } py-2 px-4`}
    >
      <ol
        className={`flex ${
          isRTL ? "flex-row-reverse" : "flex-row"
        } text-sm items-center`}
      >
        <li>
          <Link
            to="/"
            className={`${
              isDarkMode
                ? "text-gray-600 hover:text-yellow-500"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            {isRTL ? "الرئيسية" : "Home"}
          </Link>
        </li>
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          return (
            <React.Fragment key={name}>
              <li className="mx-2 text-gray-500">/</li>
              <li>
                {isLast ? (
                  <span
                    className={`${isDarkMode ? "text-white" : "text-black"}`}
                  >
                    {breadcrumbNameMap[name] || name}
                  </span>
                ) : (
                  <Link
                    to={routeTo}
                    className={`${
                      isDarkMode
                        ? "text-gray-400 hover:text-yellow-500"
                        : "text-gray-600 hover:text-gray-900"
                    }`}
                  >
                    {breadcrumbNameMap[name] || name}
                  </Link>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
